
import axios from 'axios'
import { defineComponent, onMounted, reactive,watch, toRefs ,getCurrentInstance} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import pageHead from '../common/pageHead.vue'
import {useStore} from 'vuex'
// import Footer from '@/components/common/footer.vue'
import Footer1 from '@/components/common/footer.vue'
import Footer2 from '@/components/footer/footer.vue'
import dataJson from '@/assets/json/data.json'
export default defineComponent({
    components:{pageHead,Footer1,Footer2},
    setup() {
        const route=useRoute()
        const router=useRouter()
        const {proxy,appContext}= getCurrentInstance() as any
        const axios =appContext.config.globalProperties.axios
        const platformJson=appContext.config.globalProperties.platformJson
        const store =useStore()
        onMounted(()=>{
            document.title=`${platformJson.name} - 帮助中心`
            console.log(route.query,1)
        })
        const state:any=reactive({
            filterMe:'',
            list:[
                // {
                //    title:'认识管理系统' ,
                //    icon:'&#xe608;',
                //    type:1,
                //    content:'管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系。管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系在企业中，这个总系统可分为计划经营，生产技术、劳动人事、财务成本和生活服务等子系统。它们之间，既有区别，又有联系。',
                //    path:'首页>帮助>管理>管理系统>认识管理系统'
                // },
                // {
                //    title:'认识管理系统' ,
                //    icon:'&#xe7ba;',
                //    type:2,
                //    content:'管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系。管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系在企业中，这个总系统可分为计划经营，生产技术、劳动人事、财务成本和生活服务等子系统。它们之间，既有区别，又有联系。',
                //    path:'首页>帮助>管理>管理系统>认识管理系统'
                // },
                // {
                //    title:'认识管理系统' ,
                //    icon:'&#xe6b8;',
                //    type:3,
                //    content:'管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系。管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系在企业中，这个总系统可分为计划经营，生产技术、劳动人事、财务成本和生活服务等子系统。它们之间，既有区别，又有联系。',
                //    path:'首页>帮助>管理>管理系统>认识管理系统'
                // },
                // {
                //    title:'认识管理系统' ,
                //    icon:'&#xe693;',
                //    type:4,
                //    content:'管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系。管理系统是为达到组织目标，针对机构、管理制度、管理过程、管理方法所构成的完整的组织管理体系在企业中，这个总系统可分为计划经营，生产技术、劳动人事、财务成本和生活服务等子系统。它们之间，既有区别，又有联系。',
                //    path:'首页>帮助>管理>管理系统>认识管理系统'
                // }
            ],
            pagination:{
                current:1,
                size:10,
                total:0
            }
        })
        const methods:any=reactive({
            // 跳往文章页
            handleToArticle:(val:any)=>{
                let data=val.current
                if(data.type==1){
                    router.push(`/article/${val.current.id}?bookId=${data.bookId}`)
                }else{
                    // javaDoc
                    window.open(dataJson.paas.axiosUrl+data.docPath,'_blank')
                }
            },
            // 改变页条数
            handleSizeChange:(val:any)=>{
                state.pagination.size=val
                methods.getList()
            },
            // 改变页码
            handleCurrentChange:(val:any)=>{
                state.pagination.current=val
                methods.getList()
            },
            // 获取查询列表
            searchValue:(val:String)=>{
                console.log(111)
                state.filterMe=val
                methods.getList()
            },
            getList:()=>{
                axios.get('/open/search',{
                      key:state.filterMe ,
                      pageNo:state.pagination.current,
                      pageSize:state.pagination.size
                }).then((res:any)=>{
                    let data=res.data
                   if(data.code==200){
                       state.list=data.data.list
                       state.pagination.total=Number(data.data.total)
                     }
                })
            }
        })
        watch(()=>store.state.history.searchtext,(val:any)=>{
            methods.searchValue(val)
        },{deep:true})
        return{
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
